import React, { useState, useEffect, useCallback, useMemo } from 'react';
import RepairTrackerEdit from './RepairTrackerEditForm';
import { Box, Grid, Stack, Typography } from '@mui/material';
import OtherRespondedDetailsEdit from './OtherRespondedDetailsEditForm';
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import CustomDialog from '../commoncomponents/CustomDialog';
import dayjs from "dayjs";
import { useDispatch, useSelector } from 'react-redux';
import { addRepairTrackerForVendor, checkFormSubmitForVendor, clearRepairTrackerForVendor, updateCompletionInfoDetails, updateothereRespondedDetails, updateRespondDetails } from '../../redux/actions/vendor/webFormActions';
import { getAuthToken, getCreatedBy } from '../../utility/tokenUtility';
import { DefaultCard } from '../../assets/styled-components/card';
import CustomDateTimePicker from '../commoncomponents/CustomDateTimePicker';
import CustomTextArea from '../commoncomponents/CustomTextArea';
import BottomButtonForVendorForm from './BottomButtonForVendorForm';
import BottomButtonForVendor from '../vendordashboard/BottomButtonForVendor';
import RespondedDetailsEditForm from './RespondedDetailsEditForm';
import PartReplacementEditForm from './PartReplacementEditForm.';
import PageLoader from '../commoncomponents/PageLoader';
import { useLocation, useNavigate } from 'react-router-dom';
import { processingPercentageValue, statusList } from '../../utility/message';
import { updateRepairTrackerDetails } from '../../redux/actions/workOrderActionTypes';
import CreateWOTaskDetails from '../workordercomponents/CreateWOTaskDetails';

const VendorWorkOrderEditForm = ({ setPage, buttonAttributes, page, locationState }) => {
    const createdBy = getCreatedBy('createdBy');
    const token = getAuthToken("id_token");
    const location = useLocation();
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState(null);
    const webFormData = useSelector((state) => state.vendorWebForm);
    const [otherDetails, setOtherDetails] = useState(webFormData?.otherRespondedDeatils);
    const [repairTrackerRows, setRepairTrackerRows] = useState(webFormData?.repairTracker);
    const [partReplacementRows, setPartReplacementRows] = useState(webFormData?.femunscheduledwopartsreplacedetails)
    const [openDialog, setOpenDialog] = useState(false);
    const [openErrorDialog, setOpenErrorDialog] = useState(false);
    const [openErrorDialogMssg, setOpenErrorDialogMssg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const [completionData, setCompletionData] = useState(webFormData?.completionDetails);
    const [error, setError] = useState({
        actionTaken: false,
        startDateandTime: false,
        endDateandTime: false,
        repairTrackerRows: false,
        outsourceRespondRemarks: false,
        respondFinding: false,
        taskDetails: false
    });
    const [errorMessage, setErrorMessage] = useState({
        actionTaken: "",
        startDateandTime: "",
        endDateandTime: "",
        repairTrackerRows: "",
        outsourceRespondRemarks: "",
        respondFinding: "",
        taskDetails: ""
    });

    const workOrderId = locationState?.workorderId || "";
    const workOrderType = locationState?.workOrderType || "";
    const assetCategroyType = locationState?.serviceType || "";
    const categoryType = locationState?.categoryType || "";
    const serviceType = assetCategroyType === "FEMS" ? "fem" : "bem";
    const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
    const repairCategoryFieldName = categoryType === "Scheduled" ? "sch" : "usch";
    const getstatusId = assetCategroyType === "FEMS" ? location?.state?.femworkorderstatusId || webFormData?.workderStatus : location?.state?.bemworkorderstatusId || webFormData?.workderStatus;
    const checkstatus = [4, 5, 8, 9].includes(getstatusId) ? true : false;
    const getRepairTrackerRows = webFormData?.repairTracker || [];
    const checkCategoryType = categoryType === "Scheduled" ? true : false;
    const [taskDetails, setTaskDetails] = useState({
        performanceTest: '',
        electricalSafetyTest: "",
        processStatus: ""
    });




    const taskDetailsOptions = {
        performanceTest: [{ id: 1, label: "Done" }, { id: 2, label: "Not Done" }, { id: 3, label: "Not Applicable" }, { id: 4, label: "Fail" }],
        electricalSafetyTest: [{ id: 1, label: "Done" }, { id: 2, label: "Not Done" }, { id: 3, label: "Not Applicable" }, { id: 4, label: "Fail" }],
        processStatus: [
            { id: 1, label: "Purpose For BER" },
            { id: 2, label: "Required Parts" },
            { id: 3, label: "Equipment In Use" },
            { id: 4, label: "Technical Advice" },
            { id: 5, label: "Equipment not at Location" },
            { id: 6, label: "Loaner Provision" },
            { id: 7, label: "Alternative Service" }
        ]
    };


    const handleCheckboxGroupChange = (category, newValues) => {

        setTaskDetails((prev) => ({
            ...prev,
            [category]: newValues
        }));
        setError((prev) => ({
            ...prev,
            taskDetails: false
        }));
        setErrorMessage((prev) => ({
            ...prev,
            taskDetails: ""
        }));

    };


    const handleOnchange = (value, name,) => {
        setCompletionData((previous) => {
            const updatedData = {
                ...previous,
                [name]: value,
            };
            return updatedData;
        });

        if (name === 'actionTaken' && value.trim()) {
            setError((prevError) => ({ ...prevError, actionTaken: false }));
            setErrorMessage((prevMessage) => ({ ...prevMessage, actionTaken: "" }));
        }

        let workorderDateandTime = responseData?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.workorderdate || ''
        const workOrderDateAndTime = new Date(workorderDateandTime);
        const selectedDate = new Date(value);
        const currentDate = new Date();
        const endDate = new Date(completionData?.endDateandTime);

        if (name === 'startDateandTime' && value) {

            if (selectedDate < workOrderDateAndTime || selectedDate > currentDate) {
                setError((prevErrors) => ({
                    ...prevErrors,
                    startDateandTime: true,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    startDateandTime: "Start date and time should be between Work Order date and current date/time.",
                }));
            } else {
                setError((prevErrors) => ({
                    ...prevErrors,
                    startDateandTime: false,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    startDateandTime: "",
                }));
            }

            if (endDate && selectedDate) {
                if (selectedDate >= endDate) {
                    setError((prevErrors) => ({
                        ...prevErrors,
                        endDateandTime: true,
                    }));
                    setErrorMessage((prevErrorMessages) => ({
                        ...prevErrorMessages,
                        endDateandTime: "End date and time should be on the same day and greater than the start time.",
                    }));
                } else {
                    setError((prevErrors) => ({
                        ...prevErrors,
                        endDateandTime: false,
                    }));
                    setErrorMessage((prevErrorMessages) => ({
                        ...prevErrorMessages,
                        endDateandTime: "",
                    }));
                }
            };
        };

        if (name === 'endDateandTime' && value) {
            const selectedEndDateTime = new Date(value);
            const startDateTime = new Date(completionData?.startDateandTime);
            if (
                selectedEndDateTime.toDateString() !== startDateTime.toDateString() || // If the dates are not the same
                selectedEndDateTime < startDateTime ||
                selectedEndDateTime > currentDate
            ) {
                setError((prevErrors) => ({
                    ...prevErrors,
                    endDateandTime: true,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    endDateandTime: "End date and time should be on the same day and greater than the start time.",
                }));
            } else {
                setError((prevErrors) => ({
                    ...prevErrors,
                    endDateandTime: false,
                }));
                setErrorMessage((prevErrorMessages) => ({
                    ...prevErrorMessages,
                    endDateandTime: "",
                }));
            };
        };
    };

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            if (workOrderId) {

                const response = await workOrderSummaryRepositry.getWorkOrderSummary(serviceType, workOrderId, categoryType, workOrderType);

                setResponseData(response);
                const updateCompletionData = {
                    completionId: response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}wocompletiondetails`]?.[0]?.id || "",
                    // startDateandTime: response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}wocompletiondetails`]?.[0]?.startdate || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    // endDateandTime: response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}wocompletiondetails`]?.[0]?.enddate || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    actionTaken: response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}wocompletiondetails`]?.[0]?.actiontaken || "",
                    timeStamp: response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.[`${serviceType}${categoryFieldName}wocompletiondetails`]?.[0]?.timestamp || ""
                };
                setCompletionData(updateCompletionData);
                const updatedTaskDetails = {
                    performanceTest: taskDetails?.performanceTest || response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.performancetest || '',
                    electricalSafetyTest: taskDetails?.electricalSafetyTest || response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.electricalsafteytest || '',
                    processStatus: taskDetails?.processStatus || response?.[0]?.[`${serviceType}${categoryFieldName}workorderheaders`]?.[0]?.processstatus || '',

                };
                setTaskDetails(updatedTaskDetails);
                dispatch(updateCompletionInfoDetails("UPDATE_COMPLETION_DETAILS", updateCompletionData));
            }
        };
        fetchData();
        setIsLoading(false);

    }, [serviceType, workOrderId]);



    const handleSaveClick = useCallback(async (event) => {
        event.preventDefault();

        let hasError = false;

        if (!(locationState?.isViewMode || checkstatus)) {
            // Check if completionData.actionTaken is empty or not
            if (!completionData?.actionTaken.trim()) {
                setError((prevError) => ({ ...prevError, actionTaken: true }));
                setErrorMessage((prevMessage) => ({ ...prevMessage, actionTaken: "Action Taken is required." }));
                hasError = true;
            }

            // Check if otherDetails.outsourceRespondRemarks is empty or not
            if (!otherDetails?.outsourceRespondRemarks.trim()) {
                setError((prevError) => ({ ...prevError, outsourceRespondRemarks: true }));
                setErrorMessage((prevMessage) => ({ ...prevMessage, outsourceRespondRemarks: "Outsource Respond Remarks is required." }));
                hasError = true;
            }
            if (categoryType !== "Scheduled") {
                if (!otherDetails?.respondFinding.trim()) {
                    setError((prevError) => ({ ...prevError, respondFinding: true }));
                    setErrorMessage((prevMessage) => ({ ...prevMessage, respondFinding: "Respond Finding is required." }));
                    hasError = true;
                }
            }

            // Check if there are any errors related to dates or outsourceRespondRemarks
            if (error?.startDateandTime || error?.endDateandTime || error?.outsourceRespondRemarks || error?.respondFinding) {
                hasError = true;
            }

            // // Check if there are repair tracker rows
            // if (repairTrackerRows <= 0) {
            //     setError((prev) => ({
            //         ...prev,
            //         repairTrackerRows: true,
            //     }));
            //     setErrorMessage((prev) => ({
            //         ...prev,
            //         repairTrackerRows: "Please add at least one repair tracker row.",
            //     }));
            //     hasError = true;
            // }


            if (!repairTrackerRows || repairTrackerRows.length <= 0) {
                setError((prev) => ({
                    ...prev,
                    repairTrackerRows: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    repairTrackerRows: "Please add at least one repair tracker row.",
                }));
                hasError = true;
            } else if (categoryType !== "Scheduled") {
                const missingEndDate = repairTrackerRows.some(
                    (row) => !row?.endDateandTime || row?.endDateandTime.trim() === ""
                );

                if (missingEndDate) {
                    setError((prev) => ({
                        ...prev,
                        repairTrackerRows: true,
                    }));
                    setErrorMessage((prev) => ({
                        ...prev,
                        repairTrackerRows: "Please fill the Respond End date to complete the Work Order",
                    }));
                    hasError = true;
                }
            }

            if ((!taskDetails?.performanceTest && categoryType === "Scheduled")) {
                
                setError((prev) => ({
                    ...prev,
                    taskDetails: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    taskDetails: "Please select Performance Test ",
                }));
                hasError = true;
            } else if ((!taskDetails?.electricalSafetyTest && categoryType === "Scheduled")) {
                setError((prev) => ({
                    ...prev,
                    taskDetails: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    taskDetails: "Please select Electrical Safety Test ",
                }));
                hasError = true;
            }


            // If there are any errors, return early
            if (hasError) {
                return;
            }


            const getTheSTatusId = [
                statusList?.inProgress?.id,
                statusList?.scheduled?.id,
                statusList?.open?.id,
            ];

            const sendTheStatusID = getTheSTatusId.includes(webFormData?.workderStatus) ? statusList?.inProgressOutsource?.id : webFormData?.workderStatus; //Send the status ID
            const sendCategoryID = locationState?.categoryId ? locationState?.categoryId : categoryType === "Scheduled" ? 2 : 1;
            const sendProcessingPercentage = processingPercentageValue?.assessmentTab; // Send the proceesing percentage value for assements tab


            const APIPayload = {
                respondedbyid: webFormData?.respondedDetails?.respondedByID || "",
                responsestartdate: webFormData?.respondedDetails?.respondedStartDateandTime || "",
                responseenddate: webFormData?.respondedDetails?.respondedEndDateandTime || "",
                assessmenthrs: "",
                respondedByName: "",
                respondfinding: otherDetails?.respondFinding || "",
                ispartsrequired: otherDetails.selectedPartsRequired ? (otherDetails.selectedPartsRequired === "yes" ? true : false) : "",
                isassettakenoutlocation: otherDetails.selectedAssetTakenOut ? (otherDetails.selectedAssetTakenOut === "yes" ? true : false) : "",
                vendorid: webFormData?.respondedDetails?.vendorID || "",
                Respondremarks: otherDetails?.outsourceRespondRemarks || "",
                [`${serviceType}${categoryFieldName}workorderheaderId`]: workOrderId || "",
                [`${serviceType}taskdetailsId`]: webFormData?.respondedDetails?.taskCodeID || "",
                [`${serviceType}worespondtypeId`]: webFormData?.respondedDetails?.repairTypeID || "",
                token: token,
                processstatus: taskDetails?.processStatus || "",
                electricalsafteytest: taskDetails?.electricalSafetyTest || "",
                performanceTest: taskDetails?.performanceTest || ""
            };

            const assessmentsPayload = {
                assessmentId: otherDetails.assessmentId || "",
                ispartsrequired: otherDetails.selectedPartsRequired
                    ? (otherDetails.selectedPartsRequired === "yes" ? true : false)
                    : "",
                isassettakenoutlocation: otherDetails.selectedAssetTakenOut
                    ? (otherDetails.selectedAssetTakenOut === "yes" ? true : false)
                    : "",
                respondremarks: otherDetails?.outsourceRespondRemarks,
                category: sendCategoryID,
                workorderheaderId: workOrderId || "",
                workorderstatusId: sendTheStatusID,
                processingpercentage: sendProcessingPercentage,
                respondfinding: otherDetails?.respondFinding || "",
                processstatus: taskDetails?.processStatus || "",
                electricalSafetyTest: taskDetails?.electricalSafetyTest || "",
                performanceTest: taskDetails?.performanceTest || ""
            };

            const UpdateCompletionPayload = {
                startdate: completionData.startDateandTime || "",
                enddate: completionData.endDateandTime || "",
                actiontaken: completionData.actionTaken || "",
                [`${serviceType}${categoryFieldName}workorderheaderId`]: workOrderId || "",
                id: completionData?.completionId || "",
                timestamp: completionData?.timeStamp || ""
            };

            const employeeName = await workOrderSummaryRepositry.fetchEmployeeDetails();
            const lovOptions = await workOrderSummaryRepositry.lovOptions();
            const mapEmpCode = (id) => {
                const empCode = employeeName?.find(empc => empc.id === id);
                return empCode ? empCode.employeecode : '';
            };

            const mapEmpName = (id) => {
                const empCode = employeeName?.find(empN => empN.id === id);
                return empCode ? empCode.employeename : '';
            };

            const mapFlagDesc = (id) => {
                const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
                return flagDesc ? flagDesc?.repairflag : '';
            };

            const mapPicDesc = (id) => {
                const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
                return picDesc ? picDesc?.repairpic : '';
            };

            const mapActivityDesc = (id) => {
                const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
                return activityDesc ? activityDesc?.repairactivity : '';
            };

            const updatePayload = partReplacementRows?.map((row) => ({
                itemcodeid: row?.itemPartCode?.id || "",
                quantityused: row?.quantity,
                partscost: row?.partCost,
                [`${serviceType}${categoryFieldName}workorderheaderId`]: row?.[`${serviceType}${categoryFieldName}workorderheaderId`],
                createdby: createdBy,
                [`${serviceType}${categoryFieldName}workorderheaderId`]: workOrderId,
                id: row?.id || "",
                timestamp: row?.timeStamp || ""
            }));

            try {

                if (!hasError) {
                    setIsLoading(true);
                }


                let assementsResponse = [];
                if (otherDetails?.assessmentId) {

                    assementsResponse = await workOrderSummaryRepositry.updateAssessmentsDetailsInWebForm(serviceType, assessmentsPayload);

                    if (!assementsResponse?.Status === 200) {
                        //  if (!assementsResponse?.success ) {
                        setOpenErrorDialog(true);
                        setOpenErrorDialogMssg("Failed to update assessments details.Please refresh and try again");
                        return;
                    }
                } else {
                    assementsResponse = await workOrderSummaryRepositry?.addAssessmentsDetails(serviceType, APIPayload, categoryType)
                    if (!assementsResponse?.id) {
                        setOpenErrorDialog(true);
                        setOpenErrorDialogMssg("Failed to add assessments details.Please refresh and try again");
                        return;
                    }
                };
                const assementsID = otherDetails?.assessmentId || assementsResponse?.id || ""
                const updaterRepairDetailsPayload = repairTrackerRows?.map((row) => ({
                    employeeid: row?.employeename?.id || "",
                    Vendortechnician: row?.technician || "",
                    Vendorid: webFormData?.respondedDetails?.vendorID || "",
                    repairstartdate: row?.startDateandTime || "",
                    repairenddate: row?.endDateandTime || "",
                    repairduration: row?.repairDuration || "",
                    preparationhours: row?.preparationHours || "",
                    verificationhours: row?.verificationHours || "",
                    remarks: row?.remarks || "",
                    [`${serviceType}${categoryFieldName}workorderheaderId`]: workOrderId || "",
                    [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assementsID || "",
                    [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
                    [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
                    [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
                    [`${serviceType}${categoryFieldName}wocompletiondetails`]: [],
                    createdby: createdBy,
                    id: row?.id || "",
                    timestamp: row?.timeStamp || ""
                }));

                const saveRepairTracker = await workOrderSummaryRepositry.updateRepairTracker(serviceType, updaterRepairDetailsPayload, categoryType, assementsID);
                if (!saveRepairTracker || !Array.isArray(saveRepairTracker)) {
                    setOpenErrorDialog(true);
                    setOpenErrorDialogMssg("Failed to save repair tracker details.Please refresh and try again");
                    return;
                }

                dispatch(clearRepairTrackerForVendor("CLEAR_REPAIR_TRACKER_FOR_VENDOR", []));
                saveRepairTracker?.forEach((row) => {
                    const transformedObject = {
                        employeename: {
                            employeeCode: mapEmpCode(row?.employeeid || ""),
                            employeename: mapEmpName(row?.employeeid || ""),
                            id: row?.employeeid || "",
                        },
                        technician: row?.vendortechnician || "",
                        flag: {
                            id: row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "",
                            label: mapFlagDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "")
                        },
                        pic: {
                            id: row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "",
                            label: mapPicDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "")
                        },
                        activity: {
                            id: row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "",
                            label: mapActivityDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "")
                        },
                        startDateandTime: row?.repairstartdate || "",
                        endDateandTime: row?.repairenddate || "",
                        repairDuration: row?.repairduration || "",
                        preparationHours: row?.preparationhours || "",
                        verificationHours: row?.verificationhours || "",
                        remarks: row?.remarks || "",
                        id: row?.id || "",
                        timeStamp: row?.timestamp || ""
                    };

                    dispatch(addRepairTrackerForVendor("ADD_REPAIR_TRACKER_DETAILS_FOR_VENDOR", transformedObject));
                });

                if (updatePayload?.length > 0) {

                    const addItemPartCode = await workOrderSummaryRepositry.updateItemPartCode(serviceType, updatePayload, workOrderId, categoryType);
                    if (!addItemPartCode) {
                        setOpenErrorDialog(true);
                        setOpenErrorDialogMssg("Failed to add item part code details.Please refresh and try again");
                        return;
                    }
                    dispatch({ type: "CLEAR_PART_REPLACEMENT_FOR_VENDOR", payload: [] });
                    const itemCodeResponse = await workOrderSummaryRepositry.fetchItemCodeoptions(serviceType, categoryType);
                    if (!itemCodeResponse) {
                        setOpenErrorDialog(true);
                        setOpenErrorDialogMssg("Failed to fetch item code options.Please refresh and try again");
                        return;
                    }
                    const mapItemCode = (id) => {
                        const ic = itemCodeResponse.find(ic => ic.id === id);
                        return ic ? ic.itemcode : '';
                    };

                    const mapItemDesc = (id) => {
                        const ic = itemCodeResponse.find(ic => ic.id === id);
                        return ic ? ic.descriptionname : '';
                    };

                    addItemPartCode?.forEach((row) => {
                        const transformedObject = {
                            itemDescription: mapItemDesc(row?.itemcodeid || ""),
                            itemPartCode: {
                                id: row?.itemcodeid || "",
                                label: mapItemCode(row?.itemcodeid || "")
                            },
                            partCost: row?.partscost || 0,
                            quantity: row?.quantityused || 0,
                            id: row?.id || "",
                            timeStamp: row?.timestamp || ""
                        };

                        dispatch({ type: "PART_REPLACEMENT_FOR_VENDOR", payload: transformedObject });
                    });
                };

                if (completionData?.completionId) {
                    const updCompletionInfo = await workOrderSummaryRepositry.updateCompletionInfo(serviceType, completionData?.completionId, UpdateCompletionPayload, categoryType);

                    if (!updCompletionInfo?.id) {
                        setOpenErrorDialog(true);
                        setOpenErrorDialogMssg("Failed to update completion info.Please refresh and try again");
                        return;
                    }

                    dispatch(updateCompletionInfoDetails("UPDATE_COMPLETION_DETAILS", { ...completionData, completionId: updCompletionInfo?.id, timeStamp: updCompletionInfo?.timestamp || "" }));

                } else {
                    const saveCompletionInfo = await workOrderSummaryRepositry.addCompletionInfo(serviceType, UpdateCompletionPayload, categoryType);
                    if (!saveCompletionInfo?.id) {
                        setOpenErrorDialog(true);
                        setOpenErrorDialogMssg("Failed to save completion info.Please refresh and try again");
                        return;
                    }
                    const statusUpdate = await workOrderSummaryRepositry.workorderStatusValue(serviceType, workOrderId, sendTheStatusID, sendProcessingPercentage, sendCategoryID);
                    if (!statusUpdate) {
                        setOpenErrorDialog(true);
                        setOpenErrorDialogMssg("Failed to update work order status.Please refresh and try again");
                        return;
                    }
                    dispatch(updateCompletionInfoDetails("UPDATE_COMPLETION_DETAILS", { ...completionData, completionId: saveCompletionInfo?.id, timeStamp: saveCompletionInfo?.timestamp || "" }));
                    dispatch(checkFormSubmitForVendor("UPDATE_FORMSUBMIT_STATUS", statusList?.inProgressOutsource?.id));
                };

                navigate(location?.pathname, {
                        state: {
                            ...location.state,
                            [`${serviceType}workorderstatusId`]: statusList?.inProgressOutsource?.id || "",
                            workorderstatus: statusList?.inProgressOutsource?.label || ""

                        }
                    });
                dispatch(updateothereRespondedDetails("UPDATE_OTHER_RESPONDED_DETAILS", otherDetails));

            } catch (error) {
                console.error('Error saving data:', error);
                // showErrorDialog("An error occurred: " + error.message);
            }
            finally {
                setIsLoading(false);
            }
        }

        setPage('Attachments & Signature');


    }, [repairTrackerRows, otherDetails, workOrderId, completionData, taskDetails]);

    useEffect(() => {

        const loadData = async () => {
            setIsLoading(true);
            // Update states
            setRepairTrackerRows(webFormData?.repairTracker);
            setOtherDetails(webFormData?.otherRespondedDeatils || otherDetails);
            setPartReplacementRows(webFormData?.femunscheduledwopartsreplacedetails);
            if (webFormData?.repairTracker?.length > 0) {
                setError((prev) => ({
                    ...prev,
                    repairTrackerRows: false,
                }));

                setErrorMessage((prev) => ({
                    ...prev,
                    repairTrackerRows: ""
                }))
            }
            //            setIsLoading(false);
        };

        loadData();

        if (getRepairTrackerRows?.length > 0) {
            let getFirstIndexofStartDateTime;
            let getLastIndexofEndDateTime;

            if (getRepairTrackerRows?.length === 1) {
                getFirstIndexofStartDateTime = getRepairTrackerRows[0]?.startDateandTime || "";
                getLastIndexofEndDateTime = getRepairTrackerRows[0]?.endDateandTime || "";
            } else if (getRepairTrackerRows?.length > 1) {
                getFirstIndexofStartDateTime = getRepairTrackerRows?.reduce((earliest, current) => {
                    return new Date(earliest?.startDateandTime) < new Date(current?.startDateandTime) ? earliest : current;
                })?.startDateandTime || "";
                // Find the row with the greatest endDateandTime
                getLastIndexofEndDateTime = getRepairTrackerRows.reduce((latest, current) => {
                    return new Date(latest?.endDateandTime) > new Date(current?.endDateandTime) ? latest : current;
                })?.endDateandTime || "";

                getLastIndexofEndDateTime = getLastIndexofEndDateTime || "";
            };

            setCompletionData((prev) => ({
                ...prev,
                startDateandTime: getFirstIndexofStartDateTime || dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                endDateandTime: getLastIndexofEndDateTime || dayjs().format("YYYY-MM-DDTHH:mm:ss")
            }));
        };
        setIsLoading(false);

    }, [webFormData, getRepairTrackerRows, completionData?.startDateandTime, completionData?.endDateandTime]);

    useMemo(() => {
        if (otherDetails?.outsourceRespondRemarks) {
            setError((prev) => ({
                ...prev,
                outsourceRespondRemarks: false
            }));

            setErrorMessage((prev) => ({
                ...prev,
                outsourceRespondRemarks: ""
            }));
        }

    }, [otherDetails?.outsourceRespondRemarks])

    useMemo(() => {
        if (otherDetails?.respondFinding) {
            setError((prev) => ({
                ...prev,
                respondFinding: false
            }));

            setErrorMessage((prev) => ({
                ...prev,
                respondFinding: ""
            }));
        }

    }, [otherDetails?.respondFinding])



    const handleCloseSuccessDialog = () => {
        setOpenDialog(false);
    };

    const handleCloseErrorDialog = () => {
        setOpenErrorDialog(false);
    };

    return (
        <>
            <PageLoader open={isLoading} />
            <form onSubmit={handleSaveClick} noValidate >
                <RespondedDetailsEditForm
                    locationState={locationState}
                    responseData={responseData?.[0]}
                />
                <Box mb={2} />

                <OtherRespondedDetailsEdit
                    locationState={locationState}
                    responseData={responseData?.[0]}
                    onOtherDetailsChange={setOtherDetails}
                    errorState={error?.outsourceRespondRemarks}
                    errorMesaage={errorMessage?.outsourceRespondRemarks || ""}
                    responderrorstate={error?.respondFinding}
                    responderrormessage={errorMessage?.respondFinding || ""}
                />
                <Box mb={2} />
                {/* <DefaultCard> */}
                    {checkCategoryType &&
                    <DefaultCard>
                     <Box>
                        <Typography component={"span"} color={"error"}>
                            {errorMessage?.taskDetails}
                        </Typography>
                        <CreateWOTaskDetails
                            taskDetails={taskDetails}
                            taskDetailsOptions={taskDetailsOptions}
                            onChange={handleCheckboxGroupChange}
                        />
                    </Box>
                    </DefaultCard>
                    }
                {/* </DefaultCard> */}
                <Box mb={2} />
                <DefaultCard>
                    {error?.repairTrackerRows && (
                        <Typography component={"span"} color={"error"}>
                            {errorMessage?.repairTrackerRows}*
                        </Typography>
                    )}
                    <RepairTrackerEdit
                        locationState={locationState}
                        responseData={responseData?.[0]}
                    />
                </DefaultCard>

                <Box mb={2} />

                {/* {(otherDetails?.selectedPartsRequired === "yes" || otherDetails?.selectedPartsRequired === "") && 
                    (<>
                        <PartReplacementEditForm
                            locationState={locationState}
                            responseData={responseData}
                        />
                        <Box mb={2}/>
                    </>)
                } */}

                <DefaultCard>
                    <Box >
                        <Typography variant='title2' gutterBottom>
                            Completion Info
                        </Typography>
                        <Box mb={3} />
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <CustomDateTimePicker
                                    label="Start Date and Time"
                                    onDateChange={(date) => handleOnchange(date, 'startDateandTime')}
                                    value={completionData?.startDateandTime || dayjs().format("YYYY-MM-DDTHH:mm:ss")}
                                    error={error?.startDateandTime}
                                    helperText={errorMessage?.startDateandTime || ""}
                                    disabled={(getRepairTrackerRows?.length) > 0 ? true : (locationState?.isViewMode || checkstatus)}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomDateTimePicker
                                    label="End Date and Time"
                                    onDateChange={(date) => handleOnchange(date, 'endDateandTime')}
                                    value={completionData?.endDateandTime || dayjs().format("YYYY-MM-DDTHH:mm:ss")}
                                    error={error?.endDateandTime}
                                    helperText={errorMessage?.endDateandTime || ""}
                                    disabled={(getRepairTrackerRows?.length) > 0 ? true : (locationState?.isViewMode || checkstatus)}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextArea
                                    label="Action Taken"
                                    id="actionTaken"
                                    name="actionTaken"
                                    onChange={(e) => handleOnchange(e, "actionTaken")}
                                    value={completionData?.actionTaken || ''}
                                    error={error?.actionTaken}
                                    helperText={errorMessage?.actionTaken}
                                    isMandatoryField={true}
                                    disabled={locationState?.isViewMode || checkstatus}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DefaultCard>
                {locationState?.bottomButtons && <BottomButtonForVendor page={page} buttonAttributes={buttonAttributes} />}
                {!locationState?.bottomButtons && <BottomButtonForVendorForm page={page} buttonAttributes={buttonAttributes} />}

                <CustomDialog
                    open={openDialog}
                    onClose={handleCloseSuccessDialog}
                    title="Success"
                    confirmBtn="Ok"
                    onConfirm={handleCloseSuccessDialog}
                    content="Data updated successfully."
                />
                <CustomDialog
                    open={openErrorDialog}
                    onClose={handleCloseErrorDialog}
                    title="Error"
                    confirmBtn="Ok"
                    content={openErrorDialogMssg}
                    onConfirm={handleCloseErrorDialog}
                />
            </form>
        </>
    );
};

export default VendorWorkOrderEditForm;